"use strict";

var __rest = this && this.__rest || function (s, e) {
  var t = {};

  for (var p in s) {
    if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
  }

  if (s != null && typeof Object.getOwnPropertySymbols === "function") for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
    if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
  }
  return t;
};

var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ProcessItem = void 0;

var react_1 = __importDefault(require("react"));

var prop_types_1 = __importDefault(require("prop-types"));

require("./template-1-process-item.css");

var component_library_waas_templates_constants_1 = require("@tradesorg/component-library-waas-templates.constants");

function ProcessItem(_a) {
  var position = _a.position,
      title = _a.title,
      context = _a.context,
      topCircle = _a.topCircle,
      rest = __rest(_a, ["position", "title", "context", "topCircle"]);

  var container = position && position === 'left' ? 'bg-white' : 'bg-black'; // const classTopCircle =
  //     position && position === 'left' ? 'left-top-circle' : 'center-top-circle';

  var classTitle = position && position === 'left' ? 'left-title' : 'center-title';
  var classContext = position && position === 'left' ? 'left-context' : 'center-context';
  return react_1.default.createElement("div", Object.assign({
    className: "h-full px-10 py-16 grid grid-cols-1 gap-2 ".concat(container)
  }, rest), react_1.default.createElement("h3", {
    className: " ".concat(classTitle, " text-2xl leading-7")
  }, title), react_1.default.createElement("div", {
    className: "".concat(classContext, " text-base leading-6")
  }, context));
}

exports.ProcessItem = ProcessItem;
ProcessItem.propTypes = {
  topCircle: prop_types_1.default.oneOfType([prop_types_1.default.string, prop_types_1.default.element]),
  position: prop_types_1.default.arrayOf(component_library_waas_templates_constants_1.PROCESS_ITEM_POSITION),
  title: prop_types_1.default.string,
  context: prop_types_1.default.string
};
ProcessItem.defaultProps = {
  topCircle: '01',
  position: 'left',
  title: 'Lorem ipsum dolor sit',
  context: 'Lorem ipsum dolor sit amet, consectetur adipiscing elit. Lacus vitae, dignissim auctor risus pellentesque felis dui. Lorem ipsum dolor sit amet, consectetur adipiscing elit. Lacus vitae, dignissim auctor risus pellentesque felis dui.'
};